import { proxy } from "valtio";
import type { LaunchNetworkConfig } from "@models/launchNetwork.model";
import type { AudienceDefinition } from "@models/audienceDefinition.model";

/**
 * Launch-specific store
 * Holds all data related to the currently selected launch
 */
export const launchStore = proxy<{
  // Current launch ID being viewed
  currentLaunchId: number | null;
  // Objective owning the current launch (for the population view)
  currentObjectiveId: number | null;

  // Launch-specific data
  audiences: AudienceDefinition[];
  networkConfigs: LaunchNetworkConfig[];

  // Loading states
  isLoadingAudiences: boolean;
  isLoadingNetworks: boolean;

  // Refresh triggers
  audienceRefreshTrigger: number;
}>({
  currentLaunchId: null,
  currentObjectiveId: null,

  audiences: [],
  networkConfigs: [],

  isLoadingAudiences: false,
  isLoadingNetworks: false,

  audienceRefreshTrigger: 0,
});

// Actions
export const launchActions = {
  setCurrentLaunch(launchId: number | null) {
    launchStore.currentLaunchId = launchId;
    // Clear data when switching launches
    launchStore.audiences = [];
    launchStore.networkConfigs = [];
  },

  setCurrentObjective(objectiveId: number | null) {
    launchStore.currentObjectiveId = objectiveId;
  },

  setAudiences(audiences: AudienceDefinition[]) {
    launchStore.audiences = audiences;
  },

  setNetworkConfigs(configs: LaunchNetworkConfig[]) {
    launchStore.networkConfigs = configs;
  },

  triggerAudienceRefresh() {
    launchStore.audienceRefreshTrigger++;
  },

  updateAudience(audienceId: number, updates: Partial<AudienceDefinition>) {
    const index = launchStore.audiences.findIndex((a) => a.id === audienceId);
    if (index !== -1) {
      Object.assign(launchStore.audiences[index], updates);
    }
  },

  updateNetworkConfig(network: string, updates: Partial<LaunchNetworkConfig>) {
    const index = launchStore.networkConfigs.findIndex((c) => c.network === network);
    if (index !== -1) {
      Object.assign(launchStore.networkConfigs[index], updates);
    }
  },
};